import classNames from 'classnames';
import React from 'react';

import { useMediaQuery } from '../../hooks/useMediaQuery';
import { AlmaLink } from '../alma-link';
import * as blogTypographyStyles from '../blog/blog-typography.module.css';
import { BrandIcon } from '../brand-icon';
import { SimplePortableText } from '../simple-portable-text';
import * as styles from './blog-bof-cta.module.css';

type LinkType =
	| 'directoryLink'
	| 'externalLink'
	| 'internalLink'
	| 'iterablePopup'
	| 'marketoPopup';

interface BlogBofCtaProps {
	ctaAudience: string;
	ctaBrandIcon: string;
	ctaContent: any;
	ctaHeading: string;
	ctaLinkLabel: string;
	iterablePopup?: string;
	landingPageRoute?: string;
	link?: string;
	linkType: LinkType;
	marketoPopup?: any;
	openInNewTab?: boolean;
	route?: string;
}

export const BlogBofCta: React.FC<BlogBofCtaProps> = ({
	ctaAudience,
	ctaBrandIcon,
	ctaContent,
	ctaHeading,
	ctaLinkLabel,
	iterablePopup,
	landingPageRoute,
	link,
	linkType,
	marketoPopup,
	openInNewTab,
	route,
}) => {
	// hooks
	const isMobile = useMediaQuery('(max-width: 799px)');

	const isDirectoryLink = linkType === 'directoryLink';
	const isExternalLink = linkType === 'externalLink';
	const isInternalLink = linkType === 'internalLink';
	const isIterablePopup = linkType === 'iterablePopup';
	const isMarketoPopup = linkType === 'marketoPopup';
	const isProviderCta = ctaAudience === 'provider';

	return (
		<div
			className={classNames(
				styles.container,
				isProviderCta ? styles.providerCta : styles.consumerCta
			)}
		>
			<div className={styles.headerContainer}>
				<BrandIcon
					icon={ctaBrandIcon}
					iconListColor={isProviderCta ? 'blue' : 'green'}
					iconListStyle='offsetBlob'
					iconListSize={isMobile ? 48 : 64}
				/>
				<div className={styles.headerContent}>
					<h2 className='heading-xs cdgr'>Take action:</h2>
					<h3 className={blogTypographyStyles.blogHeadingM}>
						{ctaHeading}
					</h3>
				</div>
			</div>
			<div className={styles.contentContainer}>
				<SimplePortableText blocks={ctaContent} />
			</div>
			<div className={styles.ctaContainer}>
				<AlmaLink
					analytics={{
						enableGA4: isIterablePopup || isDirectoryLink,
						ga4Event: {
							name: isIterablePopup
								? 'article_Iterable_CTA_btn'
								: 'blog_directory_CTA_btn',
						},
					}}
					cta={{
						buttonColorTheme: isProviderCta ? 'blue' : 'dark',
						iterablePopup: isIterablePopup
							? iterablePopup
							: undefined,
						kind: 'button',
						label: ctaLinkLabel,
						landingPageRoute: isInternalLink
							? landingPageRoute
							: undefined,
						link:
							isDirectoryLink || isExternalLink
								? link
								: undefined,
						marketoPopup: isMarketoPopup ? marketoPopup : undefined,
						openInNewTab:
							isDirectoryLink || isExternalLink
								? openInNewTab
								: undefined,
						route: isInternalLink ? route : undefined,
						title: ctaLinkLabel,
					}}
				/>
			</div>
		</div>
	);
};
